<template>
  <div class="index">
    <h2>《医学影像诊断学》第五版 <span>小提示: 编辑完成后，按住[Enter] 即可保存</span></h2>
    <div class="block departStructure" v-if="data.length">
      <el-tree id="tree"
        v-loading="loading"
        ref="tree"
        :data="data"
        node-key="id"
        :highlight-current="true"
        :expand-on-click-node="false"
        :indent="30"
        :filter-node-method="filterNode"
        :accordion="true"
        :props="{
          label: 'name',
          children: 'subList'
        }"
        @node-click="nodeClick"
        :default-expanded-keys="defaultExpandIds"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="level-path">{{data.levelPath}}</span>
          <el-input
            v-model="data.name"
            style="width:50%"
            placeholder="请输入"
            class="k v-check"
            size="medium"
            v-checkParams="'required'"
            @focu="dragNode=false"
            @keyup.enter.native="$event.target.blur()"
            @blur.stop="submit(data, node)"
            maxlength="100"
            show-word-limit
          ></el-input>
          <span style="margin-left:20px;margin-top: 5px;">
            <el-button type="text" size="mini" @click="() => append(data, node)" v-if="canAddChild(data, node)">增加子目录</el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data,'org_depart')">删除</el-button>
          </span>
        </span>
      </el-tree>
    </div>
    <div v-else class="content">
      <el-empty description="暂无数据"></el-empty>
    </div>
    <div>
      <el-button type="text" size="medium" @click="appendSame" icon="el-icon-edit">新建章节名称</el-button>
    </div>
  </div>
</template>

<script>
import deepCopy from '@/utils/deepcopy'
import { courseServer } from '@/api/api'
let treeid = 1000;
export default {
  data () {
    const data = [];
    return {
      data: JSON.parse(JSON.stringify(data)),
      loading: false,
      defaultExpandIds: [],  // 用于记录展开的节点
    }
  },
  mounted () {
    this.selectData()
  },
  methods: {
    selectData () {
      return new Promise((resolve, reject) => {
        courseServer.profressionDirectory().then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.data = data
          } else {
            this.$message.error(message)
          }
          resolve(res)
        }).catch((error) => {
          this.$message.error(error)
        })
      })
    },
    submit (data, node) {
      if (!data.name) {
        this.$message.error('请填写内容！')
        return
      }
      if (data.id) {
        courseServer.courseDirectoryUpdate({
          id: data.id,
          name: data.name
        }).then(res => {
          const {code, message} = res
          if (code === '0') {
            this.selectData()
            this.$message.success('修改成功')
          } else {
            this.$message.error(message)
          }
        }).catch((error) => {
          this.loading = false
          this.$message.error(error)
        })
        return
      }
      courseServer.courseDirectoryAdd({
        parentId: data.parentId,
        levelPath: data.levelPath,
        name: data.name,
        sortOrder: data.sort
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.selectData()
          this.defaultExpandIds.push(data)
          this.$message.success('添加成功')
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.loading = false
        this.$message.error(error)
      })
    },
    // 增加同级
    appendSame () {
      this.data.push(
        {
          levelPath: this.data.length + 1,
          treeid: treeid++,
          sort: this.data.length + 1,
          level: 1,
          name: '',
          subList: []
        }
      )
      this.$nextTick(() => {
        const treeElement = document.getElementById('tree');
        if (treeElement) {
          // 将滚动条滚动到最底部
          treeElement.scrollTop = treeElement.scrollHeight;
        }
      });
    },
    // 增加子集
    append (data, node) {
      console.log('444')
      node.expanded = true // 点击增加时器官树展开
      const newChild = {
        parentId: data.id,
        treeid: treeid++,
        name: '',
        sort: data.subList.length > 0 ? data.subList.length + 1 : 1,
        level: node.level + 1,
        subList: []
      };
      if (!data.subList) {
        this.$set(data, 'subList', []);
      }
      data.subList.push(newChild);
      this.indexData(this.data)
    },
    remove (node, data, dictionaryKey) {
      const parent = node.parent;
      let subList = [];
      let index = 0;
      if (!data.id) {
        if (data.level === 1) {
          subList = parent.data
        } else {
          subList = parent.data.subList
        }
        index = subList.findIndex(d => d.treeid === data.treeid)
        subList.splice(index, 1)
        return
      }
      const str = '请确认是否删除该菜单内容？'
      this.$confirm(str, '提示', { type: 'warning' }).then(
        () => {
          courseServer.courseDirectoryRemove({
            id: data.id
          }).then(res => {
            const {code, message} = res
            if (code === '0') {
              subList.splice(index, 1);
              this.$refs.tree.filter();
              this.batchUpdate()
            } else {
              this.$message.error(message)
            }
          }).catch((error) => {
            this.$message.error(error)
          });
        }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 批量更新
    async batchUpdate () {
      await this.selectData()
      this.indexData(this.data)
      let funcConfig = []
      let arr = this.data
      console.log(arr, 'aa')
      if (Array.isArray(arr)) {
        funcConfig = this.returnResult(arr).map(v => {
          return { id: v.id,  levelPath: v.levelPath}
        })
      }
      // return
      courseServer.courseBatchUpdate(JSON.stringify(funcConfig)).then(res => {
        const {code, message} = res
        if (code === '0') {
          this.selectData()
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },
    returnResult (arr) {
      let newArr = []
      for (let i = 0, length = arr.length; i < length; i++) {
        newArr.push(deepCopy(arr[i]))
        if (Array.isArray(arr[i].subList)) newArr = newArr.concat(this.returnResult(arr[i].subList))
      }
      return newArr
    },
    canAddChild(data, node) {
      return node.level && node.level < 5;
    },
    nodeClick (data, node, current) {},
    filterNode (value, data) {
      return !data.delete;
    },
    //子序列增加
    indexData (val) {
      val.forEach((item, index) => {
        item.levelPath = index + 1 + '';
        if (item.subList.length > 0) {
          _indexData(item, item.levelPath);
        }
      });
      function _indexData (item, oldIndex) {
        if (item.subList.length < 0) return;
        if (item.subList.length > 0) {
            item.subList.forEach((Item, i) => {
                Item.levelPath = oldIndex + '.' + (i + 1);
                _indexData(Item, Item.levelPath);
            });
        }
      }
      return val;
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) { // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      // 定义递归函数，用于移除所有子节点的展开状态
      const removeExpandedIds = (nodeData) => {
        if (nodeData.id) {
          const index = this.defaultExpandIds.indexOf(nodeData.id);
          if (index !== -1) {
            this.defaultExpandIds.splice(index, 1);
          }
        }
        if (nodeData.subList && nodeData.subList.length > 0) {
          nodeData.subList.forEach(child => {
            removeExpandedIds(child);
          });
        }
      };
      removeExpandedIds(data);
      // 删除当前关闭的节点
      // this.$nextTick(() => {
      //   this.defaultExpandIds.some((item, i) => {
      //     if (item === data.id) {
      //       this.defaultExpandIds.splice(i, 1)
      //     }
      //   })
      // })
    }
  }
}
</script>

<style lang='scss' scoped>
.index {
  padding: 10px;
  margin: 0 10px;
  background: #fff;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
  // height: 100%;
  max-height: calc(100vh - 70px);
  overflow: auto;
  h2 {
    span {
      font-size: 14px;
      margin-left: 10px;
      color: #F56C6C;
    }
  }
}
.block {
  margin-top: 20px;
  .custom-tree-node {
    width: 100%;
  }
  .level-path {
    display: inline-block;
    // width: 20px;
    text-align: right;
    padding-right: 5px;
  }
}
.content {
  height: calc(100vh - 172px);
}
/deep/.el-tree {
  height: calc(100vh - 172px);
  overflow: auto;
}
</style>
<style>
.el-tree-node,
.el-tree-node__content {
  margin-bottom: 5px;
  min-height: 50px;
  border-radius: 6px;
}
.el-icon-caret-right{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/chapter.vue